import React, { FC, useEffect, useState } from 'react';
import {
    Spacer,
    Row,
    Column,
    Text,
} from '@components/1-atoms';

import {
    Button,
    Dropdown,
    Input
} from '@components/2-molecules';

import styled from '@emotion/native';
import { LineItemType } from '.';

const Container = styled.View`
    align-items: center;
`;

type Props = {
    navigation?: any;
    data: LineItemType;
    onEdit?: (editedLineItem: LineItemType, index: number) => void;
    onRemove?: (removedLineItem: LineItemType, index: number) => void;
}

const LineItemEdit: FC<Props> = ({ navigation, data, onEdit, onRemove, ...props }) => {

    const [editedLineItem, setEditedLineItem] = useState(data);
    useEffect(() => { setEditedLineItem(data) }, [data]);
    
    const [tax, setTax] = React.useState({ name: `${editedLineItem.taxName} - ${editedLineItem.taxRate}%`, description: `Tax rate ${editedLineItem.taxRate}` });
    useEffect(() => { 
        setTax({ name: `${editedLineItem.taxName} - ${editedLineItem.taxRate}%`, description: `Tax rate ${editedLineItem.taxRate}` });
    }, [editedLineItem]);
    
    
    
    const updateData = (update: any): void => setEditedLineItem((prevItem: any) => ({ ...prevItem, ...update }));
    

    useEffect(() => {
    
        // AN EXAMPLE OF A RECEIPT
        // Subtotal:            $ 2.69
        // Discount           - $ 0.54
        // Total Before Taxes   $ 2.15
        // Total Taxes          $ 0.15
        // TOTAL                $ 2.30
        
        const updatedLineItem = { ...editedLineItem };

        updatedLineItem.subTotal = updatedLineItem.price * updatedLineItem.quantity;
        updatedLineItem.discount = 0;
        // updatedLineItem.discount = (updatedLineItem.subTotal * updatedLineItem.discountRate) / 100;
        updatedLineItem.totalBeforeTaxes = updatedLineItem.subTotal - updatedLineItem.discount;
        updatedLineItem.totalTaxes = updatedLineItem.taxRate ? (updatedLineItem.totalBeforeTaxes * updatedLineItem.taxRate) / 100 : 0;
        updatedLineItem.total = updatedLineItem.totalBeforeTaxes + updatedLineItem.totalTaxes;

        updateData(updatedLineItem);
    }, [editedLineItem.quantity, editedLineItem.price, editedLineItem.discountRate, editedLineItem.taxRate]);

    return (
        <Container>
            <Input
                required
                label="Quantity"
                selectTextOnFocus
                keyboardType="decimal-pad"
                inputMode="decimal"
                textalign="right"
                defaultValue={String(editedLineItem.quantity)}
                onChange={(value: any) => { updateData({ quantity: Number(value) }) }}
            />
            <Spacer h={1} />

            <Input
                required
                label="Unit price"
                selectTextOnFocus
                keyboardType="decimal-pad"
                inputMode="decimal"
                textalign="right"
                defaultValue={String(editedLineItem.price)}
                // onBlur={() => updateData({ price: lineItem.price } )}
                onChange={(value: any) => { updateData({ price: Number(value) }) }}
            />
            <Spacer h={1} />

            {/* <Input
                required
                label="Discount in percent"
                selectTextOnFocus
                keyboardType="decimal-pad"
                inputMode="decimal"
                textalign="right"
                defaultValue={String(editedLineItem.discountRate || 0.00)}
                // onBlur={() => updateData({ discountRate: lineItem.discountRate })}
                onChange={(value: any) => { updateData({ discountRate: Number(value) }) }}
            />
            <Spacer h={1} /> */}

            <Dropdown
                required
                label="Tax"
                defaultValue={tax}
                data={[]} // Populate with your tax options
            />
            <Spacer h={3} />

            <Row>
                <Column><Text small bold>Total</Text></Column>
                <Column><Text small bold decimal align="right">{editedLineItem.total}</Text></Column>
            </Row>
            <Spacer h={1.5} />

            <Button
                inset
                small
                onPress={() => onEdit?.(editedLineItem, editedLineItem.index)}
            >
                CONFIRM
            </Button>
            <Spacer h={0.5} />

            <Button
                inset
                small
                bg="transparent"
                color="#CC0808"
                onPress={() => onRemove?.(editedLineItem, editedLineItem.index)}
            >
                REMOVE
            </Button>
        </Container>
    );
};

export default LineItemEdit;
